import { render, staticRenderFns } from "./ResultAnalyteHistory.vue?vue&type=template&id=30bad849"
import script from "./ResultAnalyteHistory.vue?vue&type=script&lang=js"
export * from "./ResultAnalyteHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports